import { CourseStatisticsPresenter } from '@/presentation/presenters/problem/courseStatisticsPresenter'
import { CourseStatisticsViewModel } from '@/presentation/viewmodels/problem/courseStatisticsViewModel'

export function useCourseStatisticsPresenter(
  presenter: CourseStatisticsPresenter = new CourseStatisticsPresenter(new CourseStatisticsViewModel())
) {
  return {
    courseStatisticsList: presenter.courseStatisticsList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getCourseStatisticsListByLanguage: presenter.getCourseStatisticsListByLanguage.bind(presenter),
    clearCourseStatisticsList: presenter.clearCourseStatisticsList.bind(presenter)
  }
}
